import * as React from 'react'
//@ts-expect-error: no types for module
import Jed from 'jed'
//@ts-expect-error: no types for module
import { sprintf } from 'sprintf-js'

let i18n: Jed

export type Args =
  | Record<string | number, string | number | React.FunctionComponent | React.ReactElement>
  | string
  | number
  | React.FunctionComponent
  | React.ReactElement
  | (string | number | React.FunctionComponent | React.ReactElement)[]

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function setTranslations(translations: null | undefined | {} = {}): void {
  i18n = new Jed(translations)
}

export function t(string: string, args?: Args): string {
  let trans = i18n.gettext(string)

  if (args) {
    trans = format(trans, args)
  }

  return trans
}

export function tn(singular: string, plural: string, count = 1, args?: Args): string {
  let trans = i18n.ngettext(singular, plural, count)

  trans = format(trans, args ?? [count])

  return trans
}

export function tp(key: string, context: string, args?: Args): string {
  let trans = i18n.pgettext(context, key)

  if (args) {
    trans = format(trans, args)
  }

  return trans
}

function format(string: string, args?: Args): string {
  try {
    return sprintf(string, args)
  } catch (error) {
    return string
  }
}

export function tc(string: string, args?: Args): React.ReactElement {
  const trans = t(string, args)
  return renderComponent(trans, args)
}

export function tnc(singular: string, plural: string, count = 1, args?: Args): React.ReactElement {
  const trans = tn(singular, plural, count, args)
  return renderComponent(trans, args)
}

function renderComponent(string: string, args?: Args): React.ReactElement {
  const partRegexp = /\[([\w\d]+)(:(.[^\]]+))?\]/g
  const children: React.ReactElement[] = []

  let match = getPart()
  let lastIndex = 0

  while (match && match.length) {
    const [group, key, _subgroup, text] = match
    const { input, index } = match
    const component = args && (args as any)[key]

    // create string before match [key: text]
    if (index > lastIndex) {
      addToChildren(input.substring(lastIndex, index))
    }

    // create string for match [key: text]
    if (component) {
      addToChildren(text && text.trim(), component)
    } else {
      addToChildren(group)
    }

    lastIndex = index + group.length
    match = getPart()
  }

  // create string after last match
  if (lastIndex < string.length) {
    addToChildren(string.substring(lastIndex, string.length))
  }

  return React.createElement(
    'span',
    null,
    children.map((child, key) => React.cloneElement(child, { key: key })),
  )

  function getPart(): RegExpExecArray | null {
    return partRegexp.exec(string)
  }

  function addToChildren(text: string, dom = 'span'): void {
    let element

    if (React.isValidElement(dom)) {
      element = React.cloneElement(dom, {}, text && text.trim())
    } else {
      element = React.createElement(dom, null, text)
    }

    children.push(element)
  }
}
